<ng-container *transloco="let t"
  ><xi-generic-modal
    [canBackdropClose]="false"
    [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
    [isVisible]="true"
    (onClose)="cancel()"
  >
    <div slot="children">
      <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
        <div slot="children">
          <div class="xi-modal__container user-create__container">
            <h2 class="xi-modal__title">{{ t('user-create-dialog.create-user') }}</h2>
            <form (ngSubmit)="create()" [formGroup]="userForm">
              <div class="xi-modal__content user-create__content">
                <div class="user-create__form-container">
                  <div class="user-create__form-field">
                    <xi-input-field
                      appAutoFocus="xiInput"
                      label="{{ t('user-create-dialog.email') }}"
                      formControlName="email"
                      [prePopulateStatus]="true"
                      type="email"
                      [status]="
                        email.dirty && email.errors
                          ? { state: 'error', text: t('user-create-dialog.invalid-email') }
                          : email.dirty && !email.errors
                            ? { state: 'success' }
                            : { state: 'success' }
                      "
                      required
                    ></xi-input-field>
                  </div>

                  <div class="user-create__form-field">
                    <xi-input-field
                      label="{{ t('user-create-dialog.password') }}"
                      [type]="'password'"
                      [prePopulateStatus]="true"
                      formControlName="password"
                      [status]="userCreateStatuses.pw"
                      (onChange)="onInputChange('pw')"
                      required
                    ></xi-input-field>
                  </div>

                  <div class="user-create__form-field">
                    <xi-input-field
                      label="{{ t('user-create-dialog.confirm-password') }}"
                      [type]="'password'"
                      [prePopulateStatus]="true"
                      formControlName="passwordConfirm"
                      [status]="userCreateStatuses.pwConfirm"
                      (onChange)="onInputChange('pwConfirm')"
                      required
                    ></xi-input-field>
                  </div>

                  <div class="user-create__form-field">
                    <xi-input-field
                      label="{{ t('user-create-dialog.given-name') }}"
                      formControlName="firstName"
                      [status]="userCreateStatuses.firstName"
                      [prePopulateStatus]="true"
                      icon="cancel"
                      (onIconClick)="firstName.patchValue(''); onInputChange('firstName')"
                      (onChange)="onInputChange('firstName')"
                      required
                    ></xi-input-field>
                  </div>

                  <div class="user-create__form-field">
                    <xi-input-field
                      label="{{ t('user-create-dialog.family-name') }}"
                      formControlName="lastName"
                      [status]="userCreateStatuses.lastName"
                      [prePopulateStatus]="true"
                      icon="cancel"
                      (onIconClick)="lastName.patchValue(''); onInputChange('lastName')"
                      (onChange)="onInputChange('lastName')"
                      required
                    ></xi-input-field>
                  </div>

                  <div class="user-create__admin_wrapper">
                    <xi-checkbox
                      inputId="user-create__admin"
                      formControlName="isAdmin"
                    ></xi-checkbox>
                    <label class="kxi-text-normal" for="user-create__admin">
                      {{ t('user-create-dialog.admin') }}</label
                    >
                  </div>
                </div>

                <div class="user-create__rules-container">
                  <div class="user-create__form-field">
                    <xi-input-field
                      appAutoFocus="false"
                      label="{{ t('user-create-dialog.alt-email') }}"
                      formControlName="alternateEmail"
                      [prePopulateStatus]="true"
                      type="email"
                      [status]="
                        alternateEmail.dirty && alternateEmail.errors
                          ? { state: 'error', text: t('user-create-dialog.invalid-email') }
                          : alternateEmail.dirty && !alternateEmail.errors
                            ? { state: 'success' }
                            : { state: 'success' }
                      "
                    ></xi-input-field>
                  </div>
                  <div class="user-create__rules">
                    <app-password-rules-check
                      [password]="password.value"
                    ></app-password-rules-check>
                  </div>
                </div>
              </div>
              <div class="xi-modal__actions user-create__actions">
                <xi-default-button
                  text="{{ t('user-create-dialog.cancel') }}"
                  type="button"
                  fill="text"
                  (onClick)="cancel()"
                ></xi-default-button>

                <xi-default-button
                  text="{{ t('user-create-dialog.create') }}"
                  [disabled]="userForm.invalid"
                ></xi-default-button>
              </div>
            </form>
          </div>
        </div>
      </xi-basic-tile>
    </div>
  </xi-generic-modal>
</ng-container>
